module.exports = __webpack_public_path__ + "img/banner.6ac09954.png";